module.exports = __webpack_public_path__ + "img/header-picture.0e90cd20.jpg";